import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { SeatType } from '@vista-digital/ocapi-types/v1';
import { Validator } from '@vista-digital/validator';
const seatAppearanceTypeValidator = Validator.oneOf([...Object.values(SeatType), 'Friend']);
const seatAppearanceRuleCriteriaValidator = Validator.object({
    areaNumbers: Validator.optional(Validator.array({ minLength: 1, items: Validator.number({ min: 0 }) })),
    rowNumbers: Validator.optional(Validator.array({ minLength: 1, items: Validator.number({ min: 0 }) })),
    columnNumbers: Validator.optional(Validator.array({ minLength: 1, items: Validator.number({ min: 0 }) })),
    areaCategories: Validator.optional(Validator.array({ minLength: 1, items: nonEmptyStringValidator })),
    seatLayoutIds: Validator.optional(Validator.array({ minLength: 1, items: Validator.number({ min: 0 }) })),
    siteIds: Validator.optional(Validator.array({ minLength: 1, items: nonEmptyStringValidator })),
    seatTypes: Validator.optional(Validator.array({ minLength: 1, items: seatAppearanceTypeValidator }))
});
const partialSeatPickerSeatAppearanceConfigValidator = Validator.object({
    iconName: Validator.optional(nonEmptyStringValidator),
    showLabels: Validator.optional(Validator.boolean()),
    labelOffsetX: Validator.optional(Validator.number()),
    labelOffsetY: Validator.optional(Validator.number())
});
const partialSeatPickerSeatAppearanceStatesConfigValidator = Validator.object({
    default: Validator.optional(partialSeatPickerSeatAppearanceConfigValidator),
    selected: Validator.optional(partialSeatPickerSeatAppearanceConfigValidator),
    unavailable: Validator.optional(partialSeatPickerSeatAppearanceConfigValidator),
    house: Validator.optional(partialSeatPickerSeatAppearanceConfigValidator)
});
const seatAppearanceRuleCustomisationsValidator = Validator.object({
    className: Validator.optional(nonEmptyStringValidator),
    appearance: Validator.optional(partialSeatPickerSeatAppearanceStatesConfigValidator)
});
export const seatAppearanceRuleValidator = Validator.object({
    id: nonEmptyStringValidator,
    criteria: seatAppearanceRuleCriteriaValidator,
    customisations: seatAppearanceRuleCustomisationsValidator
});
